<template>
  <div>
    <span class="icon other"></span>
    <span class="title">Weitere Massnahmen</span>
    <p>Massnahmen zur Information und Beratung:</p>
    <ul>
      <li>Impulsberatung</li>
      <li>Kurse und Veranstaltungen</li>
      <li>Beratungsaktionen</li>
      <li>PR-Massnahmen</li>
    </ul>
    <community-selection :isModalEdit="isModalEdit" />
    <type-selection v-if="advancedCommunityId" :isModalEdit="isModalEdit" />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import CommunitySelection from '@/components/application/Intro/AdvancedActions/CommunitySelection.vue'
  import TypeSelection from '@/components/application/Intro/AdvancedActions/TypeSelection.vue'

  export default {
    data: () => ({
      isModalEdit: ''
    }),
    created () {
      this.isModalEdit = this.$route.params.modalMethod === 'bearbeiten'
    },
    computed: {
      ...mapState({
        advancedCommunityId: state => state.application.createApplication.advancedCommunityId
      })
    },
    components: {
      TypeSelection,
      CommunitySelection
    }
  }
</script>
